// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"project-card_imgWrapper__3SEJo","imgBubble":"project-card_imgBubble__S6VZ8"};